/**
 * Loader Sentry : injecte le SDK en bundle séparé, après window.load, en prod.
 *
 * Le SDK @sentry/browser n'est plus bundlé dans app.js (~-140 ko minifié sur
 * le chemin critique JS) : il vit dans un bundle autonome (sentry-init.js,
 * buildé et versionné via npm-v2/config/config-js.js) dont l'URL est exposée
 * par includes/core/Sentry.php dans la globale `sentry_bundle`.
 *
 * Entre l'exécution d'app.js et l'init du SDK, les erreurs globales (error,
 * unhandledrejection) sont mises en file d'attente puis rejouées via
 * Sentry.captureException — même principe que le loader officiel Sentry
 * (js.sentry-cdn.com). Le bundle étant servi depuis notre origine, pas de
 * domaine tiers à autoriser en CSP ni de blocage par ad blocker.
 */
import {Core} from './core'

export class SentryConfig {

  constructor() {
    if (! Core.isProd() || typeof window.sentry_bundle === 'undefined') {
      return
    }

    this.queue = []
    this.onErrorEvent = event => this.queue.push(event)
    window.addEventListener('error', this.onErrorEvent)
    window.addEventListener('unhandledrejection', this.onErrorEvent)

    if (document.readyState === 'complete') {
      this.injectSdk()
    } else {
      window.addEventListener('load', () => this.injectSdk(), {once: true})
    }
  }

  injectSdk() {
    const script = document.createElement('script')
    script.src = window.sentry_bundle.url
    script.onload = () => this.replayQueue()
    document.head.appendChild(script)
  }

  replayQueue() {
    window.removeEventListener('error', this.onErrorEvent)
    window.removeEventListener('unhandledrejection', this.onErrorEvent)

    if (typeof window.Sentry === 'undefined') {
      return
    }

    for (const event of this.queue) {
      const error = event.reason || event.error
      if (error) {
        window.Sentry.captureException(error)
      }
    }
    this.queue = []
  }

}
